import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import { ComplexValue } from 'app/types-shared';
import React from 'react';
import { LabelSpinner } from 'ui/common/label-spinner/label-spinner';
import styles from './case-types.scss';

interface CaseTypesProps {
  caseTypes: ComplexValue<number>[];
  fetching: boolean;
  translation: RiskMatrixTranslation;
  show: boolean;
}

export const CaseTypes = ({ caseTypes, translation, fetching, show }: CaseTypesProps) => {
  if (fetching) {
    return <LabelSpinner />;
  }

  const areAnyCaseTypes = caseTypes?.length > 0;

  return !show
    ? null
    : <div className={`${styles.label} col-md-12`}>
      {areAnyCaseTypes
        ? <ul>
          {translation.risk_matrix_used_for} {caseTypes.map((caseType, index) => caseType.description || caseType.longDescription
            ? <span key={caseType.value}>
              <li className={styles.item}>
                <span className={styles.labelBold}>"{caseType.description}"</span>{caseTypes.length === index + 1 ? '' : ', '}
              </li>
            </span>
            : undefined)}
        </ul>
        : translation.case_type_not_used}
    </div>;
};
